module.exports = __webpack_public_path__ + "media/images/round-left-b1f54388e6971705a17c49796ea14fb6.svg";